import React, {Component} from 'react'
import styles from './FJQuickGuideModal.module.less';
import FJLocalStore from "../../../store/FJLocalStore";
import InlineSVG from "react-inlinesvg";
import check from "../../../icon/check.svg";
import classNames from 'classnames';
import FJConfig from "../../../config/FJConfig";
import FJPureLoading from "../../../common/component/FJLoading/FJPureLoading";

class QuideTab extends Component {

  constructor(props) {
    super(props);
    this.state = {
      left: 0
    };
    this._header = React.createRef();
  }

  componentDidMount() {
    this._getLeft();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.currentIndex !== this.props.currentIndex) {
      this._getLeft();
    }
  }

  /**
   * @description 渲染
   * @private
   */
  _getComp = () => {
    return this.props.list.map((item, index) => (
      <div ref={(ele) => {
        this['item' + index] = ele
      }}
           className={classNames(styles.item, index === this.props.currentIndex ? styles.active : '')}
           key={index}
           onClick={this._onClick.bind(this, index)}
      >
        {item.text}
        <div className={styles.item_line} style={{
          width: index === this.props.currentIndex ? this.props.progress * 180 + 'px' : 0,
          display: index === this.props.currentIndex ? 'block' : 'none'
        }}/>
      </div>
    ));
  };

  /**
   * @description
   * @private
   */
  _onClick = (index) => {
    this.props.setCurrentIndex(index);
  };

  /**
   * @desc 得到选中dom的
   * @private
   */
  _getLeft = () => {
    let {currentIndex} = this.props;
    let rect = this['item' + currentIndex].getBoundingClientRect();
    let headerRect = this._header.current.getBoundingClientRect();
    this.setState({
      left: rect.left - headerRect.left
    })
  };

  render() {

    // let {
    //   left
    // } = this.state;
    //
    // let {
    //   progress
    // } = this.props;
    // <div className={styles.line} style={{left: left + 'px', width: progress * 180 + 'px'}} />

    return (
      <div className={styles.box} ref={this._header}>
        {this._getComp()}
      </div>
    );
  }
}

class FJQuickGuideModal extends Component {

  constructor(props) {
    super(props);
    const {guidePath, version} = FJConfig;
    this.state = {
      isChooseNoShow: false,
      currentIndex: 0,
      progress: 0,
      isSHowLoading: true,
      width: 667
    };
    this._video = React.createRef();
    this._guideList = [
      {
        text: FJLocalStore._('add-media'),
        url: `${guidePath}step1.mp4?v=${version}`,
      },
      {
        text: FJLocalStore._('edit-in-the-timeline'),
        url: `${guidePath}step2.mp4?v=${version}`,
      },
      {
        text: FJLocalStore._('add-effect'),
        url: `${guidePath}step3.mp4?v=${version}`,
      },
      {
        text: FJLocalStore._('preview-export'),
        url: `${guidePath}step4.mp4?v=${version}`,
      }
    ];
    this._preloadVideo = [];
  };

  componentDidMount() {
    this._upDateSize();
    window.addEventListener('resize', this._upDateSize);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.shown !== this.props.shown) {
      if (this.props.shown) {
        this._guideList.forEach((guide) => {
          let video = document.createElement('video');
          video.src = guide.url;
          video.muted = true;
          this._preloadVideo.push(video);
        });

        if (!this.state.isSHowLoading) {
          this._play();
        }
      } else {
        this._preloadVideo = [];
        window.cancelAnimationFrame(this._videoTimeOut);
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._upDateSize);
  }

  _upDateSize = () => {
    if (document.body.getBoundingClientRect) {
      let bodyHeight = document.body.getBoundingClientRect().height;
      let bodyWidth = document.body.getBoundingClientRect().width;
      let width = 667;
      if (bodyWidth <= 1180 || bodyHeight <= 800) {
        width = 500;
      }
      this.setState({
        width: width
      });
    }
  };

  _setIsChooseNoShow = () => {
    this.setState({
      isChooseNoShow: !this.state.isChooseNoShow
    });
  };

  _onClick = () => {
    window.cancelAnimationFrame(this._videoTimeOut);
    this._videoTimeOut = null;

    if (this.state.isChooseNoShow) {
      localStorage.setItem('isShowQuickGuide', 'false');
    }
    this.props.onCancel && this.props.onCancel();
  };

  _setCurrentIndex = (index) => {
    this.props.setStep(index);
    if (index === this.state.currentIndex) {
      return
    }
    this.setState({
      currentIndex: index,
      isSHowLoading: true
    })
  };

  /**
   * @description 视频加载完成
   * @private
   */
  _onloadeddata = () => {
    this.setState({
      progress: 0,
      isSHowLoading: false
    }, () => {
      this._currentDuration = this._video.current.duration;
      if (this.props.shown) {
        this._play();
      }
    })
  };

  /**
   * @description 播放视频
   * @private
   */
  _play = () => {
    let _this = this;

    function videoPlay() {
      if (!_this._video || !_this._video.current) {
        return;
      }
      let progress = _this._video.current.currentTime / _this._currentDuration;
      _this.setState({
        progress: progress
      });
      if (progress >= 1) {
        _this.setState({
          progress: 0
        }, () => {
          _this._playNext();
          window.cancelAnimationFrame(_this._videoTimeOut);
          _this._videoTimeOut = null;
        });
      } else {
        _this._videoTimeOut = window.requestAnimationFrame(videoPlay);
      }
    }

    this._videoTimeOut = window.requestAnimationFrame(videoPlay);
    this._video.current.play();
  };

  /**
   * @description 播放下一个视频
   * @private
   */
  _playNext = () => {
    let currentIndex = this.state.currentIndex;

    if (currentIndex === this._guideList.length - 1) {
      currentIndex = 0;
    } else {
      currentIndex++;
    }

    this._setCurrentIndex(currentIndex);
  };

  render() {
    let {
      isChooseNoShow,
      currentIndex,
      progress,
      isSHowLoading,
      width
    } = this.state;
    let checkClass = classNames(styles.checkbox, isChooseNoShow ? styles.active : null);
    let url = this._guideList[currentIndex].url;

    //  (758 / 420)  指的是 视频的比例
    return (
      <div className={styles.container}>
        <div className={styles.title}>
          {FJLocalStore._('view-flexClip-quick-guide')}
        </div>
        <QuideTab list={this._guideList} currentIndex={currentIndex} setCurrentIndex={this._setCurrentIndex}
                  progress={progress}/>
        <div className={styles.show_box} style={{width: width + 'px', height: width / (758 / 420) + 'px'}}>
          <div className={styles.video_box}>
            <video src={url}
                   muted={true}
                   ref={this._video}
                   onLoadedData={this._onloadeddata}
            />
            <FJPureLoading className={styles.loading} style={{display: isSHowLoading ? 'block' : 'none'}}/>
          </div>
        </div>
        <div className={styles.footer}>
          <div className={styles.check_box} onClick={this._setIsChooseNoShow}>
            <div className={checkClass}>
              <InlineSVG src={check} element='div'/>
            </div>
            <div className={styles.desc}>{FJLocalStore._('do-not-show-again')}</div>
          </div>
          <div className={styles.confirm} onClick={this._onClick}>{FJLocalStore._('got-it')}</div>
        </div>
      </div>
    );
  }
}


export default FJQuickGuideModal;
